// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3HLET","legacyBtn":"MutateMid_legacyBtn__1hCjD"};